import { CountTimer } from "./CountTimer";
export default CountTimer;
